<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import TableExpand from "../kubernetes/TableExpand.vue";
var tableDataVue = {};
export default {
  name: "TableElasticKubernetesService",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountIds: [],
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(TableExpand, {
              props: {
                row: params.row,
              },
            });
          },
        },
        {
          title: this.$t("RAM.AWS.computeInstance.accountName"),
          key: "accountName",
        },
        {
          title: this.$t("RAM.AWS.computeInstance.accountID"),
          key: "accountIdString",
        },
        {
          title: this.$t("RAM.GCP.common.projectId"),
          key: "projectId",
        },
        {
          title: this.$t("RAM.GCP.common.location"),
          key: "location",
        },
        {
          title: this.$t("RAM.GCP.Kubernetes.name"),
          key: "name",
        },
        {
          title: this.$t("RAM.GCP.Kubernetes.initialClusterVersion"),
          key: "initialClusterVersion",
        },
        {
          title: this.$t("RAM.GCP.Kubernetes.currentMasterVersion"),
          key: "currentMasterVersion",
        },
        {
          title: this.$t("RAM.GCP.Kubernetes.currentNodeVersion"),
          key: "currentNodeVersion",
        },
        {
          title: this.$t("RAM.GCP.Kubernetes.currentNodeCount"),
          key: "currentNodeCount",
        },
        {
          title: this.$t("RAM.GCP.Kubernetes.network"),
          key: "network",
        },
        {
          title: this.$t("RAM.GCP.Kubernetes.subnetWork"),
          key: "subnetWork",
        },
        {
          title: this.$t("RAM.GCP.Kubernetes.status"),
          key: "status",
        }
      ],
      tableData: [],
    };
  },
  beforeCreate: function () {
    tableDataVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function (val) {
      tableDataVue.companyId = val;
    });
    eventBus.$on("accountName", function (val) {
      tableDataVue.accountName = val;
    });
    eventBus.$on("clusterName", function (val) {
      tableDataVue.clusterName = val;
    });
  },
  mounted: function () {
    // tableDataVue.getData();
  },
  methods: {
    showAll: function () {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function () {
      // 获取搜索内容
      eventBus.$on("companyId", function (val) {
        tableDataVue.companyId = val;
      });
      eventBus.$on("accountName", function (val) {
        tableDataVue.accountName = val;
      });
      eventBus.$on("clusterName", function (val) {
        tableDataVue.clusterName = val;
      });
      this.$api.resourceManagement
        .pagingQueryGcpGke({
          accountName: tableDataVue.accountName,
          companyId: tableDataVue.companyId,
          clusterName: tableDataVue.clusterName,
          pageNum: this.current,
          pageSize: this.pageSize,
        })
        .then((res) => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function (current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function (pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    },
  },
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/kubernetes/TableElasticKubernetesService.vue